//基本盘
import Vue from 'vue'
//基本样式
import './portal/basic.scss'
import index from './portal/Main.vue'
// 全局注册神策埋点
import sensors from './utils/sensorsdata'
Vue.prototype.$sensors = sensors
// 复制粘贴插件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
new Vue({
    render: h => h(index)
}).$mount('#LandingPage');


